// src/pages/nascar/TrucksGfs.jsx
import React from "react";
import NascarGfsPage from "../../components/NascarGfsPage";

export default function TrucksGfs() {
  return (
    <NascarGfsPage
      title="Trucks GFS Model"
      seriesKey="trucks"
    />
  );
}
